import { render, staticRenderFns } from "./EventBitrate.vue?vue&type=template&id=c645469a&"
import script from "./EventBitrate.vue?vue&type=script&lang=js&"
export * from "./EventBitrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports